$(document).ready(function () {
  ("use strict");

  //bloquejar selecció de text, i d'imatges
  document.addEventListener('selectstart', function (e) {
    e.preventDefault();
  });
  document.addEventListener('contextmenu', function (e) {
    e.preventDefault();
  });
  document.addEventListener('copy', function (e) {
    e.preventDefault();
  });
  document.querySelectorAll('img').forEach(img => {
    img.setAttribute('draggable', 'false');
  });


  // -----
  // Alert
  // -----
  $(".alert button").on("click", function () {
    $(this).parent().hide();
  });

  // Menú: afegim botó i ocultem menú quan hi ha js
  $("#menu")
    .before(
      '<button class="hamburger hamburger--spring" type="button" aria-expanded="false" aria-controls="menu"><span class="hamburger-box"><span class="hamburger-inner"></span></span><span class="is-sr-only">Menu</span></button>'
    )
    .attr("hidden", "true");



  // ----
  // menú (https://polypane.rocks/blog/the-perfect-responsive-menu-2019/)
  // ----
  var toggleMenu = document.querySelector(".navigation button");
  var menu = document.querySelector("#menu");

  if (toggleMenu) {
    toggleMenu.addEventListener("click", function () {
      var open = JSON.parse(toggleMenu.getAttribute("aria-expanded"));
      toggleMenu.setAttribute("aria-expanded", !open);
      menu.hidden = !menu.hidden;
    });
  }

  $(".hamburger").on("click", function () {
    // afegir classe al botó
    $(this).toggleClass("is-active");
    // afegir classe al body
    // $("body").toggleClass("js-menu-open");
  });

  $('.descripcio').on('click', '.expand', function () {
    const $descripcio = $(this).closest('.descripcio');
    const textComplet = $descripcio.data('complet');
    $descripcio.html(textComplet);
  });
  // -------------------------------
  // Menú principal amb desplegables (https://www.w3.org/WAI/tutorials/menus/flyout/#use-button-as-toggle)
  // -------------------------------

  // var menuItems = document.querySelectorAll("#menu li.has-submenu");
  // Array.prototype.forEach.call(menuItems, function (el, i) {
  //   var activatingA = el.querySelector("a");
  //   var btn =
  //     '<button><span><span class="is-sr-only">Mostra el submenú per “' +
  //     activatingA.text +
  //     "”</span></span></button>";
  //   activatingA.insertAdjacentHTML("afterend", btn);
  //   // activatingA.setAttribute("aria-expanded", "false");

  //   el.querySelector("button").addEventListener("click", function (event) {
  //     var currentMenu = this.parentNode;
  //     Array.prototype.forEach.call(menuItems, function (el, i) {
  //       if (currentMenu !== el) {
  //         el.classList.remove("open");
  //         el.classList.add("close");
  //         //el.querySelector("a").setAttribute("aria-expanded", "false");
  //         el.querySelector("button").setAttribute("aria-expanded", "false");
  //       }
  //     });
  //     //console.log(this.parentNode.className);
  //     if (this.parentNode.classList.contains("close")) {
  //       this.parentNode.classList.add("open");
  //       this.parentNode.classList.remove("close");
  //       /*this.parentNode
  //         .querySelector("a")
  //         .setAttribute("aria-expanded", "true");*/
  //       this.parentNode
  //         .querySelector("button")
  //         .setAttribute("aria-expanded", "true");
  //     } else {
  //       this.parentNode.classList.add("close");
  //       this.parentNode.classList.remove("open");
  //       /*this.parentNode
  //         .querySelector("a")
  //         .setAttribute("aria-expanded", "false");*/
  //       this.parentNode
  //         .querySelector("button")
  //         .setAttribute("aria-expanded", "false");
  //     }
  //     event.preventDefault();
  //   });
  // });


  function hasClass(el, className) {
    return el.classList ? el.classList.contains(className) : new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
  }

  var menuItems1 = document.querySelectorAll('li.has-submenu');
  var timer1, timer2;

  var parseHTML = function(str) {
      var tmp = document.implementation.createHTMLDocument();
      tmp.body.innerHTML = str;
      return tmp.body.children;
  };

  Array.prototype.forEach.call(menuItems1, function(el, i){
      var activatingA = el.querySelector('a');
      var btn = '<button type="button"><span class="is-sr-only">Mostra el submenú de “' + activatingA.text + '”</span></button>';
      activatingA.insertAdjacentHTML('afterend', btn);

      // Handle hover event for non-touch devices
      el.addEventListener("mouseover", function(event){
          this.classList.add("open");
          this.querySelector('a').setAttribute('aria-expanded', "true");
          this.querySelector('button').setAttribute('aria-expanded', "true");
          clearTimeout(timer1);
      });

      el.addEventListener("mouseout", function(event){
          timer1 = setTimeout(function(){
              var openMenu = document.querySelector('.has-submenu.open');
              if (openMenu) {
                  openMenu.querySelector('a').setAttribute('aria-expanded', "false");
                  openMenu.querySelector('button').setAttribute('aria-expanded', "false");
                  openMenu.classList.remove("open");
              }
            // }, 500);
          });
      });

      // Handle click and touchstart events for touch devices
      el.querySelector('button').addEventListener("click", function(event){
          event.preventDefault();
          toggleSubmenu(el);
      });

      el.querySelector('button').addEventListener("touchstart", function(event){
          event.preventDefault();
          toggleSubmenu(el);
      });

      var links = el.querySelectorAll('a');
      Array.prototype.forEach.call(links, function(link, i){
          link.addEventListener("focus", function() {
              if (timer2) {
                  clearTimeout(timer2);
                  timer2 = null;
              }
          });
          link.addEventListener("blur", function(event) {
              timer2 = setTimeout(function () {
                  var openNav = document.querySelector(".has-submenu.open")
                  if (openNav) {
                      openNav.className = "has-submenu";
                      openNav.querySelector('a').setAttribute('aria-expanded', "false");
                      openNav.querySelector('button').setAttribute('aria-expanded', "false");
                  }
              }, 10);
          });
      });
  });

  function toggleSubmenu(el) {
      var isOpen = hasClass(el, "open");

      // Close any other open submenus
      var allMenus = document.querySelectorAll('li.has-submenu');
      Array.prototype.forEach.call(allMenus, function(item){
          item.classList.remove("open");
          item.querySelector('a').setAttribute('aria-expanded', "false");
          item.querySelector('button').setAttribute('aria-expanded', "false");
      });

      // Open the clicked/touched submenu if it was not already open
      if (!isOpen) {
          el.classList.add("open");
          el.querySelector('a').setAttribute('aria-expanded', "true");
          el.querySelector('button').setAttribute('aria-expanded', "true");
      }
  }

  // ---------
  // Dark mode
  // ---------
  // const btn = document.querySelector(".theme-toggle");
  // btn.addEventListener("click", function() {
  //   document.body.classList.toggle("dark-theme");
  // });

  // -----------------
  // Galeria d'imatges
  // -----------------
  // init Masonry
  var $grid = $('.gallery__grid').masonry({
    itemSelector: 'figure',
    percentPosition: true,
    columnWidth: '.grid-sizer',
    gutter: 24
  });
  // layout Masonry after each image loads
  $grid.imagesLoaded().progress( function() {
    $grid.masonry();
  });

  // ----------------
  // Dropdowns header
  // ----------------
  $('.navigation button[data-a11y-toggle]').on('click', function () {
    if ($('.main-nav li.open')) {
      $('.main-nav li.open').removeClass('open').addClass('close');
      $('.main-nav button[aria-expanded="true"').attr('aria-expanded', 'false');
    }
  });
  $('.main-nav button').on('click', function () {
    if ($('.navigation button[data-a11y-toggle][aria-expanded="true"]')) {
      $('.navigation button[data-a11y-toggle][aria-expanded="true"]').attr('aria-expanded', 'false').next('div').attr('aria-hidden', 'true');
    }
  });

  // -----
  // Print
  // -----
  $('.action-btn--print').on('click', function () {
    window.print();
  });

  // ---------
  // skip link (https://www.bignerdranch.com/blog/web-accessibility-skip-navigation-links/)
  // ---------

  // bind a click event to the 'skip' link
  $(".skip-link").click(function (event) {
    // strip the leading hash and declare
    // the content we're skipping to
    var skipTo = "#" + this.href.split("#")[1];

    // Setting 'tabindex' to -1 takes an element out of normal
    // tab flow but allows it to be focused via javascript
    $(skipTo)
      .attr("tabindex", -1)
      .on("blur focusout", function () {
        // when focus leaves this element,
        // remove the tabindex attribute
        $(this).removeAttr("tabindex");
      })
      .focus(); // focus on the content container
  });

  // ----------
  // scroll top
  // ----------
  $(window).scroll(function () {
    if ($(this).scrollTop() > 400) {
      $(".scrolltop").addClass("visible");
    } else {
      $(".scrolltop").removeClass("visible");
    }
  });

  // ------
  // Slider
  // ------
  $('.slider').slick();

  $('.slider-2').slick({
    dots: true,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 675,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.slider-3').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  // --------
  // Counters https://github.com/srexi/purecounterjs
  // --------
  new PureCounter({
    // selector: '.purecounter',
    // start: 0,
    // end: 100,
    // duration: 2,
    // delay: 10,
    // once: true,
    // repeat: false,
    // decimals: 0,
    legacy: false,
    // filesizing: false,
    // currency: false,
    separator: '.',
  });

  // --------
  // headroom
  // --------
  // $(".main-header").headroom(
    // {
    // offset: 0,
    // tolerance: 5,
    // classes: {
    //   initial: "animated",
    //   pinned: "slideDown",
    //   unpinned: "slideUp"
    // }
  // }
  // );

  // -----------
  // File upload
  // -----------
  $('input[type="file"]').change(function () {
    var i = $(this).next().find(".file-label").clone();
    var file = $('input[type="file"]')[0].files[0].name;
    $(this).next().find(".file-label").text(file);
  });

  // -----------
  // Get URL per afegir-ho al input amb class url_fomr - formulari avisan's
  // -----------
  if ($('.url_form').length) {

      let urlParams = new URLSearchParams(window.location.search);
      let urlProtocol = window.location.protocol + '//';
      let urlHost = window.location.hostname;
      let urlValue = urlParams.get("url"); // Cal posar "url" com a paràmetre

    if (urlValue) {
        $('.url_form input').val(urlProtocol+urlHost+urlValue);
    }
  }

// -----------
  // Carregar més elements per fila
  // -----------
  if ($('.rows').length) {

    // Obtenir les dades de l'atribut data-rows i data-increment del div
    $(".rows").each(function() {
      let $row = $(this); // Guarda la fila actual

      // Afegir la classe .item només als divs amb la classe .column dins de rows
      $row.find("> .column").addClass("item");

      // Obtenir les dades directament del div
      let itemsToShow = parseInt($row.attr('data-rows'), 10) || 3; // Definir itemsToShow segons data-rows, o per defecte 3
      let increment = parseInt($row.attr('data-increment'), 10) || 3; // Definir increment segons data-increment, o per defecte 3

      let $items = $row.find(".item"); // Troba els elements dins la fila
      let $button = $row.find(".loadMore"); // Troba el botó dins la fila

      $items.hide().slice(0, itemsToShow).show(); // Amaga tots i mostra els primers elements segons data-rows

      $button.click(function() {
          let hiddenItems = $row.find(".item:hidden").slice(0, increment); // Troba els elements amagats de la mateixa fila
          hiddenItems.fadeIn(); // Mostra els següents elements

          // Si ja no queden més elements amagats en aquesta fila, amaga el botó
          if ($row.find(".item:hidden").length === 0) {
              $button.hide();
          }
      });
    });
  }




  // ----
  // Tabs https://inclusive-components.design/tabbed-interfaces/
  // ----
  // if ($(".tabbed").length > 0) {
  //   $(".tabbed").each(function (index, element) {
  //     // Get relevant elements and collections
  //     var tabbed = element;
  //     var tablist = tabbed.querySelector("ul.tab-menu");
  //     var tabs = tablist.querySelectorAll("a");
  //     var panels = tabbed.querySelectorAll(".tab-panel");

  //     // The tab switching function
  //     var switchTab = function switchTab(oldTab, newTab) {
  //       newTab.focus(); // Make the active tab focusable by the user (Tab key)

  //       newTab.removeAttribute("tabindex"); // Set the selected state

  //       newTab.setAttribute("aria-selected", "true");
  //       oldTab.removeAttribute("aria-selected");
  //       oldTab.setAttribute("tabindex", "-1"); // Get the indices of the new and old tabs to find the correct
  //       // tab panels to show and hide

  //       var index = Array.prototype.indexOf.call(tabs, newTab);
  //       var oldIndex = Array.prototype.indexOf.call(tabs, oldTab);
  //       panels[oldIndex].hidden = true;
  //       panels[index].hidden = false;
  //     }; // Add the tablist role to the first <ul> in the .tabbed container

  //     tablist.setAttribute("role", "tablist"); // Add semantics are remove user focusability for each tab

  //     Array.prototype.forEach.call(tabs, function (tab, i) {
  //       tab.setAttribute("role", "tab");
  //       //	    tab.setAttribute("id", "tab" + (i + 1));
  //       tab.setAttribute("tabindex", "-1");
  //       tab.parentNode.setAttribute("role", "presentation"); // Handle clicking of tabs for mouse users

  //       tab.addEventListener("click", function (e) {
  //         e.preventDefault();
  //         var currentTab = tablist.querySelector("[aria-selected]");

  //         if (e.currentTarget !== currentTab) {
  //           switchTab(currentTab, e.currentTarget);
  //         }
  //       }); // Handle keydown events for keyboard users

  //       tab.addEventListener("keydown", function (e) {
  //         // Get the index of the current tab in the tabs node list
  //         var index = Array.prototype.indexOf.call(tabs, e.currentTarget); // Work out which key the user is pressing and
  //         // Calculate the new tab's index where appropriate

  //         var dir =
  //           e.which === 37
  //             ? index - 1
  //             : e.which === 39
  //               ? index + 1
  //               : e.which === 40
  //                 ? "down"
  //                 : null;

  //         if (dir !== null) {
  //           e.preventDefault(); // If the down key is pressed, move focus to the open panel,
  //           // otherwise switch to the adjacent tab

  //           dir === "down"
  //             ? panels[i].focus()
  //             : tabs[dir]
  //               ? switchTab(e.currentTarget, tabs[dir])
  //               : void 0;
  //         }
  //       });
  //     }); // Add tab panel semantics and hide them all

  //     Array.prototype.forEach.call(panels, function (panel, i) {
  //       panel.setAttribute("role", "tabpanel");
  //       panel.setAttribute("tabindex", "-1");
  //       var id = panel.getAttribute("id");
  //       panel.setAttribute("aria-labelledby", tabs[i].id);
  //       panel.hidden = true;
  //     }); // Initially activate the first tab and reveal the first tab panel

  //     tabs[0].removeAttribute("tabindex");
  //     tabs[0].setAttribute("aria-selected", "true");
  //     panels[0].hidden = false;
  //   });
  // }

});

// -----------
// Collapsible (https://inclusive-components.design/collapsible-sections/)
// -----------
(function () {
  // Get all the headings
  const headings = document.querySelectorAll('.collapsible__title')

  Array.prototype.forEach.call(headings, heading => {
    // Give each <h2> a toggle button child
    // with the SVG plus/minus icon
    heading.innerHTML = `
      <button aria-expanded="false" class="is-flex is-justify-content-space-between is-align-items-center">
        ${heading.innerHTML}
        <svg width="27" height="14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="m12.813 13.274-12-11.369L2.188.453 13.5 11.17 24.813.453l1.375 1.452-12 11.369a1 1 0 0 1-1.376 0Z" fill="#F60"/></svg>
      </button>
    `
    // Function to create a node list
    // of the content between this heading and the next
    const getContent = (elem) => {
      let elems = []
      while (elem.nextElementSibling && elem.nextElementSibling.className !== 'collapsible__title') {
        elems.push(elem.nextElementSibling)
        elem = elem.nextElementSibling
      }

      // Delete the old versions of the content nodes
      elems.forEach((node) => {
        node.parentNode.removeChild(node)
      })

      return elems
    }

    // Assign the contents to be expanded/collapsed (array)
    let contents = getContent(heading)

    // Create a wrapper element for `contents` and hide it
    let wrapper = document.createElement('div')
    wrapper.hidden = true

    // Add each element of `contents` to `wrapper`
    contents.forEach(node => {
      wrapper.appendChild(node)
    })

    // Add the wrapped content back into the DOM
    // after the heading
    heading.parentNode.insertBefore(wrapper, heading.nextElementSibling)

    // Assign the button
    let btn = heading.querySelector('button')

    btn.onclick = () => {
      // Cast the state as a boolean
      let expanded = btn.getAttribute('aria-expanded') === 'true' || false

      // Switch the state
      btn.setAttribute('aria-expanded', !expanded)
      // Switch the content's visibility
      wrapper.hidden = expanded
    }
  })

  if ($('.collapsible__title').length > 0 && window.location.hash.indexOf('#entry-') > -1 && $(window.location.hash).length > 0) {
    $(window.location.hash).find('button').attr('aria-expanded', true);
    $(window.location.hash).next().show();
    $('html, body').animate({
        scrollTop: $(window.location.hash).parent().offset().top
    }, 1000);
  }

})();

// -----------------
// Connected toggles (https://edenspiekermann.github.io/a11y-toggle/#connected-toggles)
// -----------------
function collapse (toggle) {
  var id = toggle.getAttribute('data-a11y-toggle');
  var collapsibleBox = document.getElementById(id);
  collapsibleBox.setAttribute('aria-hidden', true);
  toggle.setAttribute('aria-expanded', false);
}

function collapseAll (event) {
  toggles
    .filter(function (toggle) {
      return toggle !== event.target;
    })
    .forEach(collapse);
}

var toggles = Array.prototype.slice.call(
  document.querySelectorAll('.connected-toggles [data-a11y-toggle]')
);

toggles.forEach(function (toggle) {
  toggle.addEventListener('click', collapseAll);
});

  // ---------
  // Dark mode
  // ---------
//   /**
//   * Utility function to calculate the current theme setting.
//   * Look for a local storage value.
//   * Fall back to system setting.
//   * Fall back to light mode.
//   */
//   function calculateSettingAsThemeString({ localStorageTheme, systemSettingDark }) {
//     if (localStorageTheme !== null) {
//       return localStorageTheme;
//     }

//     if (systemSettingDark.matches) {
//       return "dark";
//     }

//     return "light";
//   }

//   /**
//   * Utility function to update the button text and aria-label.
//   */
//   function updateButton({ buttonEl, isDark }) {
//     const newCta = isDark ? "Mode clar" : "Mode fosc";
//     const newAriaLabel = isDark ? "Canvia al mode clar" : "Canvia al mode fosc";

//     // Update aria-label
//     buttonEl.setAttribute("aria-label", newAriaLabel);

//     // Update text node after the <img> element
//     const imgEl = buttonEl.querySelector("img"); // Find the <img> element
//     if (imgEl && imgEl.nextSibling) {
//       // Update the text node that comes immediately after the <img>
//       imgEl.nextSibling.textContent = ` ${newCta}`;
//     }
//   }

//   /**
//   * Utility function to update the theme setting on the html tag
//   */
//   function updateThemeOnHtmlEl({ theme }) {
//     document.querySelector("html").setAttribute("data-theme", theme);
//   }


// /**
// * On page load:
// */

// /**
// * 1. Grab what we need from the DOM and system settings on page load
// */
// const button = document.querySelector("[data-theme-toggle]");
// const localStorageTheme = localStorage.getItem("theme");
// const systemSettingDark = window.matchMedia("(prefers-color-scheme: dark)");

// /**
// * 2. Work out the current site settings
// */
// let currentThemeSetting = calculateSettingAsThemeString({ localStorageTheme, systemSettingDark });

// /**
// * 3. Update the theme setting and button text accoridng to current settings
// */
// updateButton({ buttonEl: button, isDark: currentThemeSetting === "dark" });
// updateThemeOnHtmlEl({ theme: currentThemeSetting });

// /**
// * 4. Add an event listener to toggle the theme
// */
// button.addEventListener("click", (event) => {
//   const newTheme = currentThemeSetting === "dark" ? "light" : "dark";

//   localStorage.setItem("theme", newTheme);
//   updateButton({ buttonEl: button, isDark: newTheme === "dark" });
//   updateThemeOnHtmlEl({ theme: newTheme });

//   currentThemeSetting = newTheme;
// });
